<template>
    <div class="card" data-testid="calendar-page">
        <div class="card-header">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-inline">
                        <label class="mr-sm-2" for="doctor">Kalendář</label>
                        <select v-model="doctorId" class="form-control mr-sm-2" aria-describedby="doctorHelp" id="doctor" placeholder="vybrat doktora" data-testid="calendar-doctor">
                            <option value="" disabled selected>zvolit doktora</option>
                            <option v-for="row in doctors" v-bind:value="row.id">{{ row.fullname }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6 text-right" v-if="doctorId">
                    <button @click="showModalCalendarLeisureTime" type="button" class="btn btn-sm btn-outline-primary" data-testid="calendar-edit-leisure"><i class="fa fa-smile-o" aria-hidden="true"></i> Upravit volno</button>
                    <button @click="showModalCalendarWorkingTime" type="button" class="btn btn-sm btn-outline-primary" data-testid="calendar-edit-working-time"><i class="fa fa-suitcase" aria-hidden="true"></i> Upravit pracovní dobu</button>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="justify-content-between d-flex">
                <div>
                    <button @click="previousPeriod()" type="button" class="btn btn-primary" data-testid="calendar-previous-week">Předchozí týden</button>
                </div>
                <div class="justify-content-between d-flex">
                    <div class="mr-sm-2">
                        <button @click="actualPeriod" class="btn btn-primary btn-sm" data-testid="calendar-current-week">Aktuální týden</button>
                    </div>
                    <div class="">
                        <datepicker v-model="selectedDate" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="chooseDate" input-class="datapickerInput" data-testid="calendar-date" v-on:input="manualSelectDate($event)"></datepicker>
                    </div>
                </div>
                <div>
                    <button @click="nextPeriod()" type="button" class="btn btn-primary" data-testid="calendar-next-week">Následující týden</button>
                </div>
            </div>
            <div class="justify-content-between d-flex">
                <div>

                </div>
                <div class="h4" data-testid="calendar-week-range">
                    {{ get_params.from }} - {{ get_params.to }} ({{ (moment(this.start_date).isoWeek()) % 2 === 1 ? 'lichý' : 'sudý' }})
                </div>
                <div>

                </div>
            </div>
            <div class="div_table">
                <table class="table table_calendar" data-testid="calendar-grid">
                    <thead>
                    <tr>
                        <th></th>
                        <th v-for="(times, index) in ((endWindow-startWindow)/windowsPerHour)" :colspan="windowsPerHour">
                            {{ (index+startHour)<10 ? '0'+(index+startHour) : (index+startHour) }}
                        </th>
                    </tr>
                    <tr>
                        <th></th>
                        <th v-for="(times, index) in ((endWindow-startWindow)/(windowsPerHour/2))" :colspan="(windowsPerHour/2)" class="halfHour">
                            &nbsp;
                        </th>
                    </tr>
                    <tr>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody v-if="calendar !== false" style="line-height: 1.2">
                    <template v-for="n in 7">
                      <tr>
                        <td v-on:click="getVisitsForDay( moment(render_start_date).add(n - 1, 'days').format('L'))" :data-testid="'calendar-day-' + moment(render_start_date).add(n - 1, 'days').format('YYYY-MM-DD')">{{ moment(render_start_date).add(n - 1, 'days').format('dddd') }}<br><small>{{ moment(render_start_date).add(n - 1, 'days').format('L') }}</small></td>
                        <td v-for="(cell, indexTM) in (endWindow-startWindow)"
                            :data-window-id="(n - 1) + '_' +  (startWindow + cell - 1)"
                            :data-testid="'calendar-cell-' + (n - 1) + '-' + (startWindow + cell - 1)"
                            v-on:click="getVisitsForWindow( moment(render_start_date).add(n - 1, 'days').format('L'), startWindow + cell - 1)"
                            :class="getRightClassForTd(calendar[n-1][cell + startWindow - 1]) + ' ' + ((cell%windowsPerHour === 0) ? 'hourly' : '' ) + ' ' + ((cell%windowsPerHour === windowsPerHour/2) ? 'halfhourly' : '' )"
                            v-tooltip="{
                                  content: calendar[n-1][cell + startWindow - 1]['visit'].length > 0 ? windowsHoverVisits(calendar[n-1][cell + startWindow - 1]['visit']) : '',
                                  placement: 'bottom-center',
                                  classes: ['info']}">
                          &nbsp;
                          <template v-for="visit in calendar[n-1][cell + startWindow - 1]['visit']">
                            <div style="position: relative;">
                              <div class="visit_slot"
                                   style="position: absolute;"
                                   :style="{ backgroundColor: '#' + visit.visit_purpose.color, top: visit.row_slot_number*6 + 'px' }"
                                   :title="visitSlotHover(visit)"
                                   :data-testid="'calendar-visit-strip-' + visit.id">
                              </div>
                            </div>
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                        <template v-for="(cell, indexTM) in (endWindow-startWindow)">
                          <td v-if="calendar[n-1][cell + startWindow - 1]['skipNote'] === 0 || calendar[n-1][cell + startWindow - 1]['type'] !== 'work'" :colspan="calendar[n-1][cell + startWindow - 1]['note'] ? calendar[n-1][cell + startWindow - 1]['note']['windowsCount'] : 1"
                              style="position: relative">
                            <!--                                  style="position: relative" :class="getRightClassForTd(calendar[n-1][cell + startWindow - 1]) + ' ' + ((cell%windowsPerHour === 0) ? 'hourly' : '' ) + ' ' + ((cell%windowsPerHour === windowsPerHour/2) ? 'halfhourly' : '' )">-->
                            <div style="position: absolute; overflow: hidden; text-overflow: ellipsis; width: 100%; text-align: center;">
                              {{ calendar[n-1][cell + startWindow - 1]['note'] ? calendar[n-1][cell + startWindow - 1]['note']['text'] : '' }}
                            </div>
                          </td>
                        </template>
                      </tr>
                    </template>
                    </tbody>
                    <tbody v-else="">
                        <tr v-for="n in 7">
                            <td>{{ moment(render_start_date).add(n - 1, 'days').format('dddd') }}<br><small>{{ moment(render_start_date).add(n - 1, 'days').format('L') }}</small></td>
                            <td v-for="(cell, indexTM) in (endWindow-startWindow)" class="blank_windows">
                                &nbsp;
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="table_overlay" v-if="calendar === false || calendarPending === true">
                    <div class="" v-if="calendarPending === true">
                        <div><i class="fa fa-spinner fa-pulse fa-fw fa-4x" aria-hidden="true"></i></div>
                        <div><span class="h4"> </span></div>
                    </div>
                    <div class="text-danger"v-else-if="calendar === false">
                        <div><i class="fa fa-exclamation-circle fa-4x" aria-hidden="true"></i></div>
                        <div><span class="h4">Musíte zvolit doktora</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body" v-if="visits.length > 0" data-testid="calendar-visits">
            <table class="table">
                <thead>
                <tr>
                    <th></th>
                    <th>Datum / čas<br>Klient</th>
                    <th></th>
                    <th>Důvod návštěvy</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(visit, index) in (visits)" class="card-text">
                    <tr :data-testid="'calendar-visit-' + visit.id">
                        <td rowspan="2" class="align-middle">
                            <i class="fa fa-2x fa-circle-o text-info" aria-hidden="true" v-if="visit.state === 'scheduled'"></i>
                            <i class="fa fa-2x fa-clock-o text-success" aria-hidden="true" v-else-if="visit.state === 'arrived'"></i>
                            <i class="fa fa-2x fa-check-circle text-success" aria-hidden="true" v-else-if="visit.state === 'completed'"></i>
                            <i class="fa fa-2x fa-dot-circle-o text-warning" aria-hidden="true" v-else-if="visit.state === 'elaborated'"></i>
                            <i class="fa fa-2x fa-times-circle-o text-danger" aria-hidden="true" v-else-if="visit.state === 'failed'"></i>
                            <i class="fa fa-2x fa-dot-circle-o text-danger" aria-hidden="true" v-else-if="visit.state === 'excused'"></i>
                            <i class="fa fa-2x fa-times-circle text-danger" aria-hidden="true" v-else-if="visit.state === 'canceled'"></i>
                            <!--<visit-change-state v-on:update="getDoctorsDayVisits" :actual-state="visit.state" :selected-doctor-id="visit.planned_for.id" :visit-id="visit.id"></visit-change-state>-->
                        </td>
                        <td class="align-middle">
                            <template v-if="visit.hasData">
                                <button @click="showHideVisitDetail(index)" class="btn btn-sm btn_extra_small btn-primary"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
                            </template>
                            {{ visit.date }} od {{visit.timeFrom}} do {{visit.timeTo}} ({{ visit.duration * 5 | minutesToCsTime }})
                        </td>
                        <td>

                        </td>
                        <td colspan="2" class="align-middle">
                            <b>{{ visit.visit_purpose.purpose }}</b>
                            <template v-if="editingVisitId === visit.id "><label for="note">poznámka: </label>
                                <form class="form-inline" @submit.prevent="putVisit(visit)">
                                    <input v-model="editingVisit.note" type="text" class="form-control ml-sm-1 mr-sm-2" aria-describedby="noteHelp" id="note">
                                    <button v-if="!waitForSave" type="submit" class="btn btn-primary">Uložit</button>
                                    <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                                </form>
                            </template>
                            <template v-else=""><button @click="editVisit(visit.note, visit.id)" class="btn btn-sm btn-link text-secondary" :data-testid="'calendar-visit-edit-' + visit.id"><i class="fa fa-pencil" aria-hidden="true"></i></button><i>poznámka: {{ visit.note }}</i></template>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3" class="border-top-0">
                            <router-link class="text-secondary" :to="{ name: 'ShowClient', params: { clientid: visit.client.id }}"><i class="fa fa-address-card-o" aria-hidden="true"></i></router-link> <b>{{ visit.client.first_name }} {{ visit.client.last_name }}</b> - <b>{{ visit.client.p_i_n }}</b>
                            <span class="badge badge-secondary" v-if="visit.client.health_insurance">{{ visit.client.health_insurance.code }}</span>
                            <span class="badge badge-warning" v-else=""><i class="fa fa-warning" aria-hidden="true"></i> chybí zdrav. pojišťovna</span>
                            <span class="badge badge-primary" v-if="visit.client.membership">{{ visit.client.membership.name }}</span>
                            <span class="badge badge-warning" v-else=""><i class="fa fa-warning" aria-hidden="true"></i> nemá program</span>
                            <span class="badge badge-warning" v-if="visit.client.missing_data"><i class="fa fa-danger" aria-hidden="true"></i> chybějící údaje</span>
                            <span class="badge badge-warning" v-if="visit.client.missing_contact"><i class="fa fa-danger" aria-hidden="true"></i> chybějící kontakty</span>
                        </td>
                        <td colspan="1" class="border-top-0 text-right">
                            {{ visit.planned_for.fullname }}
                            <!--<visit-change-doctor v-on:update="getDoctorsDayVisits" :doctors="doctors" :selected-doctor-id="visit.planned_for.id" :visit-id="visit.id"></visit-change-doctor>-->
                        </td>
                    </tr>
                    <tr v-if="showedVisitDetail.indexOf(index) > -1">
                        <td class="border-top-0">

                        </td>
                        <td class="" colspan="2">
                            <div class="row m-0" v-if="visit.presenting_complaint">
                                <h6>{{ visit.presenting_complaint.anamnesis_type.name }}</h6>
                                <div v-html="visit.presenting_complaint.text"></div>
                            </div>
                            <div class="" v-else-if="visit.medical_report">
                                <h6>Výsledná zpráva</h6>
                                <div v-html="visit.medical_report.text"></div>
                            </div>
                        </td>
                        <td class="" colspan="2">
                            <div class="">
                                <h6>Diagnózy a výkony</h6>
                                <div>
                                    <table class="table">
                                        <tbody>
                                        <template v-for="diagnose in visit.diagnosis">
                                            <tr>
                                                <td>{{ diagnose.disease.code }}</td>
                                                <td>{{ diagnose.disease.name_cs }}</td>
                                            </tr>
                                            <template v-if="diagnose.actions.length > 0">
                                                <tr v-for="action in diagnose.actions">
                                                    <td></td>
                                                    <td>
                                                        {{ action.operation.code }} - {{ action.operation.name }}
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-else="">
                                                <tr>
                                                    <td></td>
                                                    <td>
                                                        <i>(diagnóza nemá přidělené výkony)</i>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="">
                                <h6>Léčiva</h6>
                                <div>
                                    <template v-if="visit.medicament.length > 0">
                                        <table class="table">
                                            <tbody>
                                            <tr v-for="m in visit.medicament">
                                                <td>{{ m.medicine ? m.medicine.label : '' }}
                                                  {{ m.individual_medicine ? m.individual_medicine.name : '' }}</td>
                                                <td>{{ m.dosage }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </template>
                                    <template v-else="">
                                        <i>žádný lék nepředepsán</i>
                                    </template>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div class="card-body" v-else-if="visitsPending">
            <div class="text-center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
                (načítám)
            </div>
        </div>
        <calendar-leisure-time :opened="showModalCalendarLeisureTimeOpened" :doctor-id="doctorId" v-on:leisure-time-updated="loadCalendar"></calendar-leisure-time>
        <calendar-working-time :opened="showModalCalendarWorkingTimeOpened" :doctor-id="doctorId" v-on:working-time-updated="loadCalendar"></calendar-working-time>
    </div>
</template>

<script>
  import moment from 'moment'
  import apiMixin from '@/mixins'
  import CalendarLeisureTime from '../modals/LeisureTime.vue'
  import CalendarWorkingTime from '../modals/WorkingTime.vue'

  export default {
    data () {
      return {
        waitForSave: false,
        calendarSize: 'week',
        startWindow: 43, // TODO změnit ze settings ordinace (záčátek standardní pracovní doby)
        endWindow: 127, // TODO změnit ze setting ordinace (konec standardní pracovní doby)
        windowsPerHour: 6, // TODO změnit ze setting ordinace (velikost "okénka")
        startHour: 7,
        selectedWindow: null,
        lastDuration: '',
        selected_element: null,
        get_params: {
          from: '',
          to: '',
          doctorid: ''
        },
        start_date: '',
        end_date: '',
        begin_of_month: '',
        end_of_month: '',
        today: moment(),
        actual_select: {
          selected: false,
          time: '',
          date: '',
          window: '',
          day: ''
        },
        modalOpened: false,
        render_end_date: '',
        render_start_date: '',
        selectedDate: null,
        // NEW:
        calendar: false,
        calendarPending: false,
        calendarError: false,
        doctors: null,
        doctorsPending: false,
        doctorsError: false,
        doctorId: null,
        // MODALS
        showModalCalendarLeisureTimeOpened: false,
        showModalCalendarWorkingTimeOpened: false,
        // Visits for window
        visits: false,
        visitsPending: false,
        visitsError: false,
        showedVisitDetail: [],
        editingVisitId: false,
        editingVisit: {}
      }
    },
    mixins: [apiMixin],
    methods: {
      editVisit (note, id) {
        this.editingVisitId = id
        this.editingVisit = {
          note: note
        }
      },
      putVisit () {
        this.waitForSave = true
        this.$http.put('visit/' + this.editingVisitId, this.editingVisit, {emulateJSON: true}).then(response => {
          this.waitForSave = false
          this.editingVisitId = false
          this.editingVisit = {}
          // this.getDayVisits(getParams) TOTO - Add auto reload after visit updated (put)
        }, response => {
          this.errors = response.data.errors
          this.waitForSave = false
        })
      },
      showModalCalendarLeisureTime () {
        this.showModalCalendarLeisureTimeOpened = true
        this.showModal('calendar-leisure-time')
      },
      showModalCalendarWorkingTime () {
        this.showModalCalendarWorkingTimeOpened = true
        this.showModal('calendar-working-time')
      },
      showModal (name) {
        this.$modal.show(name)
      },
      window10toTime (num) {
        let hoursFrom = Math.floor((num - 1) / 6)
        let hoursTo = Math.floor(num / 6)
        let minutesFrom = ((num - 1) % 6) * 10
        let minutesTo = ((num) % 6) * 10
        return hoursFrom + ':' + minutesFrom.toString().padStart(2, 0) + ' - ' + hoursTo + ':' + minutesTo.toString().padStart(2, 0)
      },
      windowToTime (window) {
        window = window - 1
        let hour = Math.floor(window / this.windowsPerHour)
        let minute = (window % this.windowsPerHour) * 15
        return moment().hour(hour).minute(minute)
      },
      clearLastSelect () {
        if (this.selectedWindow) {
          var element = this.selectedWindow
          for (var i = 0; i < this.lastDuration; i++) {
            element.classList.remove('selected_window')
            if (element.nextSibling === null) {
              break
            }
            element = element.nextSibling
          }
        }
      },
      getRightClassForTd (item) {
        let classes = item.type

        if (item.clients > 0) {
          classes += ' clients'
        }

        return classes
      },
      getVisitsForWindow (date, window) {
        this.visits = false
        this.showedVisitDetail = []
        let getParams = {
          date: date,
          planned_for: this.doctorId,
          window: window,
          states: JSON.stringify(['scheduled', 'arrived', 'elaborated', 'completed'])
        }
        this.getDayVisits(getParams)
        // console.log('ziskavam navstevy pro' + date + ' okno: ' + window)
      },
      getVisitsForDay (date) {
        this.visits = false
        let getParams = {
          date: date,
          planned_for: this.doctorId,
          states: JSON.stringify(['scheduled', 'arrived', 'elaborated', 'completed'])
        }
        this.getDayVisits(getParams)
        // console.log('ziskavam navstevy pro' + date + ' okno: ' + window)
      },
      initialSet () {
        moment.locale('cs')
        this.get_params = {
          from: '',
          to: '',
          doctorid: ''
        }
        this.actualPeriod()
      },
      getCalendar () {
        this.getWeekCalendarForDoctor(this.get_params.doctorid, this.get_params)
      },
      actualPeriod () {
        this.start_date = moment().startOf('isoWeek')
        this.end_date = moment().endOf('isoWeek')
        this.renderDates()
        this.loadCalendar()
      },
      nextPeriod () {
        this.start_date = this.start_date.add(1, 'weeks')
        this.end_date = this.end_date.add(1, 'weeks')
        this.renderDates()
        this.loadCalendar()
      },
      previousPeriod () {
        this.start_date = this.start_date.subtract(1, 'weeks')
        this.end_date = this.end_date.subtract(1, 'weeks')
        this.renderDates()
        this.loadCalendar()
      },
      renderDates () {
        this.render_start_date = this.start_date
        this.render_end_date = this.end_date
        this.get_params.date = moment(this.start_date).format('DD.MM.YYYY')
        this.get_params.from = moment(this.start_date).format('DD.MM.YYYY')
        this.get_params.to = moment(this.end_date).format('DD.MM.YYYY')
      },
      loadCalendar () {
        this.get_params.doctorid = this.doctorId
        if (this.doctorId !== null && this.doctorId !== undefined) {
          this.getCalendar()
        }
      },
      moment: function (date) {
        return moment(date)
      },
      init () {
        this.initialSet()
        this.getDoctors()
        this.selectedDate = null
        this.loadCalendar()
      },
      manualSelectDate (value) {
        this.start_date = moment(value).startOf('isoWeek')
        this.end_date = moment(value).endOf('isoWeek')
        this.renderDates()
        this.loadCalendar()
        this.selectedDate = null
      },
      showHideVisitDetail (index) {
        if (this.showedVisitDetail.indexOf(index) === -1) {
          this.showedVisitDetail.push(index)
        } else {
          this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1)
        }
      },
      findDoctorById (doctor) {
        return doctor.id === this.doctorId
      },
      windowsHover (num) {
        return '00:00'
      },
      windowsHoverVisits (visits) {
        let returnString = ''
        visits.forEach(function (visit) {
          returnString += '<br>' + visit.visit.timeFrom + ' - ' + visit.visit.timeTo + '<br>' + visit.visit_purpose.purpose
        })

        return returnString
      },
      visitSlotHover (visit) {
        return visit.visit_purpose.purpose
      }
    },
    watch: {
      doctorId (val) {
        this.visits = false
        if (val !== null && val !== undefined) {
          document.title = 'clinico - ' + this.doctors.find(this.findDoctorById).fullname
          this.loadCalendar()
        }
      }
    },
    beforeMount () {
      this.init()
    },
    components: {
      CalendarLeisureTime,
      CalendarWorkingTime
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .icon-male {
        color: dodgerblue;
        font-weight: bold;
    }

    .icon-female {
        color: deeppink;
        font-weight: bold;
    }

    .bold_text {
        font-weight: bold;
    }
    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }

    .visit_slot {
      height: 6px;
      width: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/views/Calendar/components/Calendar.vue?2008d488